import $ from 'jquery';
import { breakpoint } from '../variables/variables.js';
import { createSwiperToggle } from '../functions/functions.js';

// Последние новости
$( () => {
	createSwiperToggle( '.news-slider', () => {
		return breakpoint.isTablet;
	} );
} );
